var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentskiBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18125_12228",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18125_12228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.6155 20C4.15517 20 3.77083 19.8458 3.4625 19.5375C3.15417 19.2292 3 18.8448 3 18.3845V8H4V18.3845C4 18.5385 4.06408 18.6796 4.19225 18.8077C4.32042 18.9359 4.4615 19 4.6155 19H18V20H4.6155ZM8.6155 16C8.15517 16 7.77083 15.8458 7.4625 15.5375C7.15417 15.2292 7 14.8448 7 14.3845V4H22V14.3845C22 14.8448 21.8458 15.2292 21.5375 15.5375C21.2292 15.8458 20.8448 16 20.3845 16H8.6155ZM10 12H14V7H10V12ZM15 12H19V10H15V12ZM15 9H19V7H15V9Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentskiBlog);
export default __webpack_public_path__ + "static/media/studentski-blog.07c87347b6510c2a5ac2c849e59a75b3.svg";
export { ForwardRef as ReactComponent };